module.exports = __webpack_public_path__ + "static/img/bugar_2.040acc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bugar_2.png
// module id = wX7p
// module chunks = 0